var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D0E2E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#EAF2F2",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4998 24V28M28.4998 32H28.5098M26.7898 18.86L18.3198 33C18.1451 33.3024 18.0527 33.6453 18.0518 33.9945C18.0508 34.3437 18.1413 34.6871 18.3142 34.9905C18.4871 35.2939 18.7365 35.5467 19.0375 35.7238C19.3385 35.9009 19.6806 35.9961 20.0298 36H36.9698C37.319 35.9961 37.6611 35.9009 37.9621 35.7238C38.2631 35.5467 38.5124 35.2939 38.6854 34.9905C38.8583 34.6871 38.9488 34.3437 38.9478 33.9945C38.9468 33.6453 38.8544 33.3024 38.6798 33L30.2098 18.86C30.0315 18.5661 29.7805 18.3231 29.481 18.1544C29.1814 17.9858 28.8435 17.8972 28.4998 17.8972C28.156 17.8972 27.8181 17.9858 27.5186 18.1544C27.2191 18.3231 26.968 18.5661 26.7898 18.86Z",
    stroke: "#01625F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d21122b98cb79fec40856e969f993262.svg";
export { ForwardRef as ReactComponent };